import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { useGetPluginInstance } from '@/shared/services/instances/hooks/use-get-plugin-instances';
import { useGetInitializeInstanceByGuid } from '@/shared/services/instances/hooks/use-get-initialize-instance';
import { useSetInstanceServiceModeByGuid } from '@/shared/services/instances/hooks/use-set-instance-service-mode';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { InstanceView } from '../InstanceView';
var HuMessageStateType;
(function (HuMessageStateType) {
    HuMessageStateType[HuMessageStateType["InstanceValidationCompleted"] = 1] = "InstanceValidationCompleted";
    HuMessageStateType[HuMessageStateType["InstanceSerializationCompleted"] = 3] = "InstanceSerializationCompleted";
    HuMessageStateType[HuMessageStateType["InstanceSerializationFailed"] = 4] = "InstanceSerializationFailed";
    HuMessageStateType[HuMessageStateType["InstanceDataChunksCreated"] = 5] = "InstanceDataChunksCreated";
    HuMessageStateType[HuMessageStateType["InstanceDataChunksCreationFailed"] = 6] = "InstanceDataChunksCreationFailed";
    HuMessageStateType[HuMessageStateType["InstanceQueuedForFileLoad"] = 7] = "InstanceQueuedForFileLoad";
    HuMessageStateType[HuMessageStateType["InstanceAllFilesLoaded"] = 8] = "InstanceAllFilesLoaded";
    HuMessageStateType[HuMessageStateType["InstanceHasSendToHead"] = 9] = "InstanceHasSendToHead";
    HuMessageStateType[HuMessageStateType["HeadMessageReceivedFromPlugin"] = 10] = "HeadMessageReceivedFromPlugin";
    HuMessageStateType[HuMessageStateType["HeadWorkflowReady"] = 11] = "HeadWorkflowReady";
    HuMessageStateType[HuMessageStateType["HeadTransformationReady"] = 12] = "HeadTransformationReady";
    HuMessageStateType[HuMessageStateType["HeadIntegrationReady"] = 13] = "HeadIntegrationReady";
    HuMessageStateType[HuMessageStateType["InstanceMessageReceivedFromHead"] = 14] = "InstanceMessageReceivedFromHead";
    HuMessageStateType[HuMessageStateType["HeadWaitForExternalSystem"] = 15] = "HeadWaitForExternalSystem";
    HuMessageStateType[HuMessageStateType["InstanceReadyToIntegrationPlugin"] = 16] = "InstanceReadyToIntegrationPlugin";
    HuMessageStateType[HuMessageStateType["InstanceIntegrationPluginExecutionComplete"] = 17] = "InstanceIntegrationPluginExecutionComplete";
    HuMessageStateType[HuMessageStateType["HeadTransformationFailed"] = 18] = "HeadTransformationFailed";
    HuMessageStateType[HuMessageStateType["InstanceIntegrationPluginExecutionFailed"] = 19] = "InstanceIntegrationPluginExecutionFailed";
    HuMessageStateType[HuMessageStateType["InstanceObjectServePluginExecutionComplete"] = 20] = "InstanceObjectServePluginExecutionComplete";
    HuMessageStateType[HuMessageStateType["InstanceObjectServePluginExecutionFailed"] = 21] = "InstanceObjectServePluginExecutionFailed";
    HuMessageStateType[HuMessageStateType["HeadMessagePaused"] = 22] = "HeadMessagePaused";
    HuMessageStateType[HuMessageStateType["HeadWorkComplete"] = 100] = "HeadWorkComplete";
})(HuMessageStateType || (HuMessageStateType = {}));
// Агент догружается по guid, а не берётся из списка: так drawer открывается
// и по прямой ссылке на агента, которого нет на текущей странице.
export const InstanceDetails = ({ guid }) => {
    const { setAction } = useActionLogger();
    const { data: instanceDetails } = useGetPluginInstance(`?guid=${guid}`);
    const { refetch: getInitialize } = useGetInitializeInstanceByGuid(guid, false);
    const { refetch: setInstanceServiceMode } = useSetInstanceServiceModeByGuid(guid, false);
    const handleInitializationClick = () => {
        getInitialize().then(({ data }) => {
            if (!data?.isSuccess) {
                setAction({
                    type: 'error',
                    message: data?.errorFullMessage,
                });
            }
            else {
                setAction({
                    type: 'success',
                    message: 'Agent initialized successfully',
                });
            }
        });
    };
    const formatErrorMessage = (array) => {
        const preparedArray = array.map((message) => HuMessageStateType[message.stateType]);
        const formattedErrorMsg = [...new Set(preparedArray)].join(', ');
        return `The agent was not switched to the service mode, because the messages of ${formattedErrorMsg} types are not processed`;
    };
    const handleSetInstanceServiceMode = () => {
        setInstanceServiceMode().then(({ data }) => {
            if (!data?.isSuccess) {
                setAction({
                    type: 'error',
                    message: formatErrorMessage(data?.notCompletedMessageInfos),
                });
            }
            else {
                setAction({
                    type: 'success',
                    message: 'Agent successfully switched to service mode',
                });
            }
        });
    };
    if (instanceDetails && !instanceDetails.isSuccess) {
        return (React.createElement(Box, { p: 9 },
            React.createElement(Typography, { variant: "h5" }, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430")));
    }
    if (!instanceDetails?.pluginInstanceInfo) {
        return null;
    }
    return (React.createElement(InstanceView, { instanceDetails: instanceDetails.pluginInstanceInfo, actions: React.createElement(React.Fragment, null,
            React.createElement(Button, { variant: "contained", color: "primary", onClick: handleInitializationClick }, "\u0418\u043D\u0438\u0446\u0438\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C"),
            React.createElement(Box, { ml: 2 },
                React.createElement(Button, { variant: "outlined", color: "primary", onClick: handleSetInstanceServiceMode }, "\u041F\u0435\u0440\u0435\u0432\u0435\u0441\u0442\u0438 \u0432 \u0440\u0435\u0436\u0438\u043C \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F"))) }));
};
